const ls = (key, fallback) => localStorage.getItem(key) || fallback;

export const state = {
  layoutType:   ls('layoutType',   'semibox'),
  layoutWidth:  ls('layoutWidth',  'fluid'),
  sidebarSize:  ls('sidebarSize',  'lg'),
  topbar:       ls('topbar',       'light'),
  mode:         ls('mode',         'light'),
  position:     ls('position',     'fixed'),
  sidebarView:  ls('sidebarView',  'default'),
  sidebarColor: ls('sidebarColor', 'dark'),
  sidebarImage: ls('sidebarImage', 'none'),
  preloader:    ls('preloader',    'disable'),
  visibility:   ls('visibility',   'show'),
  colorTheme:   ls('colorTheme',   'orange'),
};

export const mutations = {
  CHANGE_LAYOUT(state, layoutType) {
    state.layoutType = layoutType;
  },
  CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
    state.layoutWidth = layoutWidth;
  },
  CHANGE_SIDEBAR_TYPE(state, sidebarSize) {
    state.sidebarSize = sidebarSize;
  },
  CHANGE_TOPBAR(state, topbar) {
    state.topbar = topbar;
  },
  CHANGE_MODE(state, mode) {
    state.mode = mode;
  },
  CHANGE_POSITION(state, position) {
    state.position = position;
  },
  CHANGE_SIDEBAR_VIEW(state, sidebarView) {
    state.sidebarView = sidebarView;
  },
  CHANGE_SIDEBAR_COLOR(state, sidebarColor) {
    state.sidebarColor = sidebarColor;
  },
  CHANGE_SIDEBAR_IMAGE(state, sidebarImage) {
    state.sidebarImage = sidebarImage;
  },
  CHANGE_PRELOADER(state, preloader) {
    state.preloader = preloader;
  },
  CHANGE_VISIBILITY(state, visibility) {
    state.visibility = visibility;
  },
  CHANGE_COLOR_THEME(state, colorTheme) {
    state.colorTheme = colorTheme;
  },
};

export const actions = {
  changeLayoutType({ commit }, { layoutType }) {
    commit('CHANGE_LAYOUT', layoutType);
    localStorage.setItem('layoutType', layoutType);
    document.body.removeAttribute('style');
  },

  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit('CHANGE_LAYOUT_WIDTH', layoutWidth);
    localStorage.setItem('layoutWidth', layoutWidth);
  },

  changeSidebarSize({ commit }, { sidebarSize }) {
    commit('CHANGE_SIDEBAR_TYPE', sidebarSize);
    localStorage.setItem('sidebarSize', sidebarSize);
  },

  changeTopbar({ commit }, { topbar }) {
    commit('CHANGE_TOPBAR', topbar);
    localStorage.setItem('topbar', topbar);
  },

  changeMode({ commit }, { mode }) {
    commit('CHANGE_MODE', mode);
    localStorage.setItem('mode', mode);
  },

  changePosition({ commit }, { position }) {
    commit('CHANGE_POSITION', position);
    localStorage.setItem('position', position);
  },

  changeSidebarView({ commit }, { sidebarView }) {
    commit('CHANGE_SIDEBAR_VIEW', sidebarView);
    localStorage.setItem('sidebarView', sidebarView);
  },

  changeSidebarColor({ commit }, { sidebarColor }) {
    commit('CHANGE_SIDEBAR_COLOR', sidebarColor);
    localStorage.setItem('sidebarColor', sidebarColor);
  },

  changeSidebarImage({ commit }, { sidebarImage }) {
    commit('CHANGE_SIDEBAR_IMAGE', sidebarImage);
    localStorage.setItem('sidebarImage', sidebarImage);
  },

  changePreloader({ commit }, { preloader }) {
    commit('CHANGE_PRELOADER', preloader);
    localStorage.setItem('preloader', preloader);
  },

  changeVisibility({ commit }, { visibility }) {
    commit('CHANGE_VISIBILITY', visibility);
    localStorage.setItem('visibility', visibility);
  },

  changeColorTheme({ commit }, { colorTheme }) {
    commit('CHANGE_COLOR_THEME', colorTheme);
    localStorage.setItem('colorTheme', colorTheme);
  },
};
